var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.data != null)?[_vm._v(" Prvotní konfigurace stanice ")]:[_c('LoadingData')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }